module.exports = __webpack_public_path__ + "static/media/jack.3f002f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jack.png
// module id = 982
// module chunks = 0